import { unFormatCurrency } from "@/common/utils/unFormatters";
import z from "zod";

export const bankingDepositCreateSchema = z.object({
  requested_total: z
    .string({ message: 'Preencha o valor aportado' })
    .min(1, { message: 'Preencha o valor aportado' })
    .refine((value) => unFormatCurrency(value) > 0, { message: 'O valor deve ser maior que R$ 0,00' }),
  payment_method: z.object({
    id: z.string(),
    display_name: z.string(),
  }),
});

export type BankingDepositCreateValidationSchema = z.infer<typeof bankingDepositCreateSchema>;
